import type { DefaultDashboardDefinition } from './dashboard-definition';

export const inventoryDashboard: DefaultDashboardDefinition = {
  id: "inventory.main",
  appId: "inventory",
  name: "Inventory dashboard",
  record: null,
  queryScope: null,
  placements: [
    {
      id: 'inventory.products-in-stock.default',
      widgetId: 'inventory.products-in-stock',
      placement: {x: 0, y: 8, width: 12, height: 5},
    },
    {
      id: "inventory.valuation-trend.default",
      widgetId: "inventory.valuation-trend",
      placement: {
        x: 0,
        y: 0,
        width: 6,
        height: 3,
      },
    },
    {
      id: "inventory.movement-trend.default",
      widgetId: "inventory.movement-trend",
      placement: {
        x: 6,
        y: 0,
        width: 6,
        height: 3,
      },
    },
    {
      id: "inventory.event-count.default",
      widgetId: "inventory.event-count",
      placement: {
        x: 0,
        y: 3,
        width: 4,
        height: 1,
      },
    },
    {
      id: "inventory.units-moved.default",
      widgetId: "inventory.units-moved",
      placement: {
        x: 4,
        y: 3,
        width: 4,
        height: 1,
      },
    },
    {
      id: "inventory.receipts.default",
      widgetId: "inventory.receipts",
      placement: {
        x: 8,
        y: 3,
        width: 4,
        height: 1,
      },
    },
    {
      id: "inventory.event-types.default",
      widgetId: "inventory.event-types",
      placement: {
        x: 0,
        y: 4,
        width: 6,
        height: 4,
      },
    },
    {
      id: "inventory.movement-report.default",
      widgetId: "inventory.movement-report",
      placement: {
        x: 6,
        y: 4,
        width: 6,
        height: 4,
      },
    },
  ],
};
